interface RouteMetaOptions {
    requiresAuth?: boolean
    permissions?: string[]
    isSubShow?: boolean
    subIndex?: string
    subGroup?: string
    subGroupName?: string
    hasSubMenuGroup?: boolean
    subMenuGroup?: string
    subMenuGroupIndex?: string
    icon?: string
    alternativeGroup?: string
}

interface RouteMeta {
    requiresAuth: boolean
    permissions: string[] | undefined
    isSubShow: boolean
    subIndex: string
    subGroup: string | undefined
    subGroupName: string
    hasSubMenuGroup: boolean
    subMenuGroup: string
    subMenuGroupIndex: string
    icon: string
    alternativeGroup: string
}

export default function createAuthRouteMeta(options: RouteMetaOptions): RouteMeta {
    const {
        requiresAuth = true,
        permissions,
        isSubShow = false,
        subIndex = "",
        subGroup,
        subGroupName = "",
        hasSubMenuGroup = false,
        subMenuGroup = "",
        subMenuGroupIndex = "",
        icon = "",
        alternativeGroup = "",
    } = options

    if (isSubShow && Object.values(options).some((param) => param === undefined)) {
        throw Error("缺乏所需的參數")
    }

    if (!isSubShow && [permissions, subGroup].some((param) => param === undefined)) {
        throw Error("缺乏所需的參數")
    }

    return {
        requiresAuth,
        permissions,
        isSubShow,
        subIndex,
        subGroup,
        subGroupName,
        hasSubMenuGroup,
        subMenuGroup,
        subMenuGroupIndex,
        icon,
        alternativeGroup,
    }
}
